{
 "air-squat": {
  "assetId": "47141301",
  "file": "47141301-Air-Squat-(VERSION-2)_Thighs",
  "gymvisualProductId": 10894,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "arnold-press": {
  "assetId": "21371301",
  "file": "21371301-Dumbbell-Arnold-Press_Shoulders",
  "gymvisualProductId": 4176,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "assisted-pull-up": {
  "assetId": "25291301",
  "file": "25291301-Assisted-Pull-up-(female)_Back",
  "gymvisualProductId": 5541,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "back-extension": {
  "assetId": "44551301",
  "file": "44551301-45-degrees-Back-Extension_Hips",
  "gymvisualProductId": 11527,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "back-squat": {
  "assetId": "35931301",
  "file": "35931301-Barbell-Squat-(female)_Thighs",
  "gymvisualProductId": 9871,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-bent-over-row": {
  "assetId": "08921301",
  "file": "08921301-Band-bent_Back-over-row_Back",
  "gymvisualProductId": 2367,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-biceps-curl": {
  "assetId": "40631301",
  "file": "40631301-Band-Biceps-Curl_Upper-Arms",
  "gymvisualProductId": 10130,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-chest-fly": {
  "assetId": "40751301",
  "file": "40751301-Band-Chest-Fly-(male)_Chest",
  "gymvisualProductId": 12042,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-chest-press": {
  "assetId": "09201301",
  "file": "09201301-Band-standing-chest-press_Chest",
  "gymvisualProductId": 2395,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-clamshell": {
  "assetId": "21501301",
  "file": "21501301-Resistance-Band-Clam_Hips",
  "gymvisualProductId": 4745,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-external-shoulder-rotation": {
  "assetId": "09211301",
  "file": "09211301-Band-standing-external-shoulder-rotation_Back",
  "gymvisualProductId": 2396,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-front-raise": {
  "assetId": "09781301",
  "file": "09781301-Band-front-raise_Shoulders",
  "gymvisualProductId": 2450,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-glute-bridge": {
  "assetId": "21541301",
  "file": "21541301-Resistance-Band-Glute-Bridge_Hips",
  "gymvisualProductId": 4749,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-glute-kickback": {
  "assetId": "67981301",
  "file": "67981301-Resistance-Band-Standing-Balance-Glute-Kickback-(female)_Hips",
  "gymvisualProductId": 17027,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-good-morning": {
  "assetId": "15131301",
  "file": "15131301-Band-Good-Morning_Hips",
  "gymvisualProductId": 3376,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-hammer-curl": {
  "assetId": "08971301",
  "file": "08971301-Band-hammer-curl_Forearms",
  "gymvisualProductId": 2372,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-hip-thrust": {
  "assetId": "27601301",
  "file": "27601301-Resistance-Band-Hip-Thrust_Hips",
  "gymvisualProductId": 6121,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-internal-shoulder-rotation": {
  "assetId": "09241301",
  "file": "09241301-Band-standing-internal-shoulder-rotation_Back",
  "gymvisualProductId": 2399,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-kneeling-lat-pulldown": {
  "assetId": "09051301",
  "file": "09051301-Band-kneeling-pulldown_Back",
  "gymvisualProductId": 2380,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-lateral-raise": {
  "assetId": "09071301",
  "file": "09071301-Band-lateral-raise_Shoulders",
  "gymvisualProductId": 2382,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-lateral-walk": {
  "assetId": "24601301",
  "file": "24601301-Resistance-Band-Lateral-Walk_Hips",
  "gymvisualProductId": 5494,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-overhead-press": {
  "assetId": "52051301",
  "file": "52051301-Resistance-Band-Overhead-Shoulder-Press_Shoulders",
  "gymvisualProductId": 12417,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-pallof-press": {
  "assetId": "09791301",
  "file": "09791301-Band-horizontal-Pallof-Press_Waist",
  "gymvisualProductId": 2451,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-pull-apart": {
  "assetId": "15031301",
  "file": "15031301-Band-Pull-Apart_Shoulders",
  "gymvisualProductId": 3366,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-reverse-fly": {
  "assetId": "09931301",
  "file": "09931301-Band-reverse-fly_Shoulders",
  "gymvisualProductId": 2465,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-romanian-deadlift": {
  "assetId": "10091301",
  "file": "10091301-Band-stiff-leg-deadlift_Hips",
  "gymvisualProductId": 2481,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-seated-row": {
  "assetId": "09181301",
  "file": "09181301-Band-seated-row_Back",
  "gymvisualProductId": 2393,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-shoulder-pass-through": {
  "assetId": "83651301",
  "file": "83651301-Resistance-Band-Pass-Through_Shoulders",
  "gymvisualProductId": 19256,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-single-arm-row": {
  "assetId": "45691301",
  "file": "45691301-Resistance-Band-One-Arm-Bent-Over-Row_Back",
  "gymvisualProductId": 12293,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-squat": {
  "assetId": "71971301",
  "file": "71971301-Resistance-Band-Squat-(female)_Thighs",
  "gymvisualProductId": 17737,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-standing-hip-abduction": {
  "assetId": "38531301",
  "file": "38531301-Resistance-Band-Standing-Hip-Abduction_Hips",
  "gymvisualProductId": 9977,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-triceps-pushdown": {
  "assetId": "46881301",
  "file": "46881301-Resistance-Band-Triceps-Pushdown_Upper-Arms",
  "gymvisualProductId": 12345,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "band-upright-row": {
  "assetId": "09341301",
  "file": "09341301-Band-upright-row_Shoulders",
  "gymvisualProductId": 2409,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "banded-face-pull": {
  "assetId": "08961301",
  "file": "08961301-Band-face-pull_Shoulders",
  "gymvisualProductId": 2371,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "bar-dip": {
  "assetId": "81431301",
  "file": "81431301-Triceps-Dip-on-High-Parallel-Bars-(male)_Upper-Arms",
  "gymvisualProductId": 18884,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "bar-hang": {
  "assetId": "50551301",
  "file": "50551301-Dead-Hang-Stretch_Stretching",
  "gymvisualProductId": 11528,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-curl": {
  "assetId": "35921301",
  "file": "35921301-Barbell-Curl-(female)_Upper-Arms",
  "gymvisualProductId": 9870,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-floor-press": {
  "assetId": "37241301",
  "file": "37241301-Barbell-Floor-Chest-Press_Chest",
  "gymvisualProductId": 8911,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-high-pull": {
  "assetId": "101061301",
  "file": "101061301-Barbell-High-Pull-(male)_Shoulders",
  "gymvisualProductId": 22108,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-hip-thrust": {
  "assetId": "22161301",
  "file": "22161301-Barbell-Hip-Thrust-(female)_Hips",
  "gymvisualProductId": 4286,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-lunge": {
  "assetId": "00541301",
  "file": "00541301-Barbell-Lunge_Thighs",
  "gymvisualProductId": 1548,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-lying-triceps-extension": {
  "assetId": "00611301",
  "file": "00611301-Barbell-Lying-Triceps-Extension_Upper-Arms",
  "gymvisualProductId": 1555,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-rear-delt-row": {
  "assetId": "00761301",
  "file": "00761301-Barbell-Rear-Delt-Row_shoulder",
  "gymvisualProductId": 1570,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-row": {
  "assetId": "22421301",
  "file": "22421301-Barbell-Bent-Over-Row-(female)_Back",
  "gymvisualProductId": 4312,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-shrug": {
  "assetId": "24801301",
  "file": "24801301-Barbell-Shrug-(female)_Back",
  "gymvisualProductId": 5928,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-standing-calf-raise": {
  "assetId": "13721301",
  "file": "13721301-Barbell-Standing-Calf-Raise_Calves",
  "gymvisualProductId": 3142,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-thruster": {
  "assetId": "33051301",
  "file": "33051301-Barbell-Thruster",
  "gymvisualProductId": 7199,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-upright-row": {
  "assetId": "22291301",
  "file": "22291301-Barbell-Upright-Row-(female)_Shoulders",
  "gymvisualProductId": 4299,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "barbell-wrist-curl-behind-the-back": {
  "assetId": "24811301",
  "file": "24811301-Barbell-Standing-Back-Wrist-Curl-(female)_Forearms",
  "gymvisualProductId": 5929,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "battle-ropes": {
  "assetId": "25651301",
  "file": "25651301-Battling-Ropes-(female)",
  "gymvisualProductId": 5578,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "behind-the-neck-press": {
  "assetId": "26031301",
  "file": "26031301-Barbell-Seated-Behind-Head-Military-Press-(female)_Shoulders",
  "gymvisualProductId": 5997,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "belt-squat": {
  "assetId": "29501301",
  "file": "29501301-Lever-Belt-Squat_Thighs",
  "gymvisualProductId": 6763,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "bench-press": {
  "assetId": "24401301",
  "file": "24401301-Barbell-Bench-Press-(female)_Chest",
  "gymvisualProductId": 5907,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "bicycle-crunch": {
  "assetId": "62121301",
  "file": "62121301-Bicycle-Crunch-(female)_Waist",
  "gymvisualProductId": 15581,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "bird-dog-reps": {
  "assetId": "01351301",
  "file": "01351301-Bird-Dog-(female)_Waist-FIX",
  "gymvisualProductId": 4395,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "box-jump": {
  "assetId": "05091301",
  "file": "05091301-Jump-Box_Plyometrics",
  "gymvisualProductId": 2007,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "box-squat": {
  "assetId": "49621301",
  "file": "49621301-Barbell-Box-Squat_Hips",
  "gymvisualProductId": 11278,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "bulgarian-split-squat": {
  "assetId": "35331301",
  "file": "35331301-Bulgarian-Split-Squat_Thighs",
  "gymvisualProductId": 8120,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "burpee": {
  "assetId": "27941301",
  "file": "27941301-Burpee-(female)_Cardio",
  "gymvisualProductId": 6182,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-chest-press": {
  "assetId": "10661301",
  "file": "10661301-Cable-Standing-Chest-Press-(female)_Chest-FIX",
  "gymvisualProductId": 2526,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-close-grip-seated-row": {
  "assetId": "26611301",
  "file": "26611301-Cable-Seated-Row-with-V-bar_Back",
  "gymvisualProductId": 6668,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-crossover": {
  "assetId": "81411301",
  "file": "81411301-Cable-Standing-Crossover-(male)_Chest",
  "gymvisualProductId": 18882,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-crunch": {
  "assetId": "23691301",
  "file": "23691301-Cable-Kneeling-Crunch-(female)_Waist",
  "gymvisualProductId": 5246,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-curl": {
  "assetId": "01561301",
  "file": "01561301-Cable-Curl_Upper-Arms",
  "gymvisualProductId": 1649,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-external-shoulder-rotation": {
  "assetId": "02351301",
  "file": "02351301-Cable-Standing-Shoulder-External-Rotation_Back-FIX",
  "gymvisualProductId": 1728,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-front-raise": {
  "assetId": "22301301",
  "file": "22301301-Cable-Front-Raise-(female)_Shoulders",
  "gymvisualProductId": 4300,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-hip-abduction": {
  "assetId": "27551301",
  "file": "27551301-Cable-Hip-Abduction-(toe-out)-(female)_Hips",
  "gymvisualProductId": 6116,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-horizontal-wood-chop": {
  "assetId": "112511301",
  "file": "112511301-Cable-Kneeling-Woodchop-(VERSION-3)_Waist",
  "gymvisualProductId": 24429,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-internal-shoulder-rotation": {
  "assetId": "50881301",
  "file": "50881301-Cable-Shoulder-Internal-Rotation_Shoulders",
  "gymvisualProductId": 13552,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-kickback": {
  "assetId": "26401301",
  "file": "26401301-Cable-kickback-(female)_Upper-arms",
  "gymvisualProductId": 6028,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-lateral-raise": {
  "assetId": "30541301",
  "file": "30541301-Cable-Lateral-Raise-(female)_Shoulders",
  "gymvisualProductId": 8267,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-pull-through": {
  "assetId": "12061301",
  "file": "12061301-Cable-pull-through_hips",
  "gymvisualProductId": 2656,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-reverse-curl": {
  "assetId": "29531301",
  "file": "29531301-Cable-Standing-Reverse-Grip-Curl-(Straight-bar)-(female)_Forearms",
  "gymvisualProductId": 6766,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-reverse-fly": {
  "assetId": "02251301",
  "file": "02251301-Cable-Standing-Cross-over-High-Reverse-Fly_Shoulders",
  "gymvisualProductId": 1671,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-rope-hammer-curl": {
  "assetId": "01651301",
  "file": "01651301-Cable-Hammer-Curl-(with-rope-attachment)-(male)_Forearms-FIX",
  "gymvisualProductId": 1658,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-row": {
  "assetId": "22451301",
  "file": "22451301-Cable-Seated-Row-(female)_Back",
  "gymvisualProductId": 4315,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-shrug": {
  "assetId": "25791301",
  "file": "25791301-Cable-Shrug-(female)_Back",
  "gymvisualProductId": 5975,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-upright-row": {
  "assetId": "02461301",
  "file": "02461301-Cable-Upright-Row_Shoulders-FIX",
  "gymvisualProductId": 1739,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cable-wide-grip-seated-row": {
  "assetId": "02181301",
  "file": "02181301-Cable-Seated-Wide-grip-Row_Back",
  "gymvisualProductId": 1711,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "calf-raise": {
  "assetId": "30181301",
  "file": "30181301-Standing-Calf-Raise-(female)_Calves-FIX",
  "gymvisualProductId": 8236,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "calf-raise-in-leg-press": {
  "assetId": "22121301",
  "file": "22121301-Sled-Calf-Press-On-Leg-Press-(female)_Calves",
  "gymvisualProductId": 4282,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "captain-s-chair-knee-raises": {
  "assetId": "51071301",
  "file": "51071301-Captains-Chair-Leg-Raise_Hips",
  "gymvisualProductId": 11273,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "captain-s-chair-leg-raises": {
  "assetId": "46141301",
  "file": "46141301-Captains-Chair-Straight-Leg-Raise-(female)_Waist",
  "gymvisualProductId": 12325,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "chest-dip": {
  "assetId": "02511301",
  "file": "02511301-Chest-Dip_Chest",
  "gymvisualProductId": 1744,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "chin-up": {
  "assetId": "23791301",
  "file": "23791301-Chin-Up-(female)_Back",
  "gymvisualProductId": 5338,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "clean-and-jerk": {
  "assetId": "51901301",
  "file": "51901301-Barbell-Clean-and-Jerk_Weightlifting",
  "gymvisualProductId": 19622,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "clean-deadlift": {
  "assetId": "15151301",
  "file": "15151301-Barbell-Clean-Deadlift_Thighs",
  "gymvisualProductId": 3378,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "close-grip-bench-press": {
  "assetId": "23911301",
  "file": "23911301-Barbell-Close-Grip-Bench-Press-(female)_Upper-Arms",
  "gymvisualProductId": 5350,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "close-grip-push-up": {
  "assetId": "02591301",
  "file": "02591301-Close-Grip-Push-up_Upper-Arms-FIX",
  "gymvisualProductId": 1752,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "core-twist": {
  "assetId": "25381301",
  "file": "25381301-Russian-Twist-(female)_waist",
  "gymvisualProductId": 5550,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cossack-squat": {
  "assetId": "25691301",
  "file": "25691301-Cossack-Squats-(female)_Thighs-FIX",
  "gymvisualProductId": 5587,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "crunch": {
  "assetId": "47271301",
  "file": "47271301-Crunch-(arms-on-chest)-(female)_Waist",
  "gymvisualProductId": 10908,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "curtsy-lunge": {
  "assetId": "63181301",
  "file": "63181301-Single-Curtsy-Lunge-(female)_Hips-FIX",
  "gymvisualProductId": 17873,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "cycling": {
  "assetId": "28381301",
  "file": "28381301-Bicycle_Pilates",
  "gymvisualProductId": 6342,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dead-bug": {
  "assetId": "30711301",
  "file": "30711301-Dead-Bug-(female)_Waist",
  "gymvisualProductId": 8284,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "deadlift": {
  "assetId": "22141301",
  "file": "22141301-Barbell-Deadlift-(female)_Hips",
  "gymvisualProductId": 4284,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "decline-bench-press": {
  "assetId": "00331301",
  "file": "00331301-Barbell-Decline-Bench-Press_Chest",
  "gymvisualProductId": 1527,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "decline-bench-sit-up": {
  "assetId": "24491301",
  "file": "24491301-Decline-Sit-up-(female)_Hips",
  "gymvisualProductId": 5915,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "decline-push-up": {
  "assetId": "02801301",
  "file": "02801301-Decline-Push-up_Chest",
  "gymvisualProductId": 1773,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "deep-squat-sit-hold": {
  "assetId": "63441301",
  "file": "63441301-Holding-Squat-(male)_Thighs",
  "gymvisualProductId": 21569,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "deficit-deadlift": {
  "assetId": "57021301",
  "file": "57021301-Barbell-Deadlift-from-Deficit_Hips",
  "gymvisualProductId": 14254,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "donkey-calf-raise": {
  "assetId": "26771301",
  "file": "26771301-Donkey-Calf-Raise-(female)_Calves",
  "gymvisualProductId": 6054,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dragon-flag": {
  "assetId": "52641301",
  "file": "52641301-Negative-Dragon-Flag-(female)_Waist",
  "gymvisualProductId": 12426,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-bench-press": {
  "assetId": "22541301",
  "file": "22541301-Dumbbell-Bench-Press-(female)_Chest",
  "gymvisualProductId": 4324,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-bulgarian-split-squat": {
  "assetId": "22901301",
  "file": "22901301-Dumbbell-Bulgarian-Split-Squat-(female)_Thighs",
  "gymvisualProductId": 4904,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-chest-press": {
  "assetId": "02891301",
  "file": "02891301-Dumbbell-Bench-Press_Chest",
  "gymvisualProductId": 1782,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-curl": {
  "assetId": "02941301",
  "file": "02941301-Dumbbell-Biceps-Curl_Upper-Arms",
  "gymvisualProductId": 1787,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-decline-chest-press": {
  "assetId": "03011301",
  "file": "03011301-Dumbbell-Decline-Bench-Press_Chest",
  "gymvisualProductId": 1794,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-floor-press": {
  "assetId": "36681301",
  "file": "36681301-Dumbbell-Lying-on-Floor-Chest-Press_Chest",
  "gymvisualProductId": 8890,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-fly": {
  "assetId": "03081301",
  "file": "03081301-Dumbbell-Fly_Chest-FIX",
  "gymvisualProductId": 1801,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-front-raise": {
  "assetId": "03101301",
  "file": "03101301-Dumbbell-Front-Raise_Shoulders-FIX",
  "gymvisualProductId": 1803,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-lunge": {
  "assetId": "03361301",
  "file": "03361301-Dumbbell-Lunge_Hips-FIX",
  "gymvisualProductId": 1837,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-lying-triceps-extension": {
  "assetId": "03511301",
  "file": "03511301-Dumbbell-Lying-Triceps-Extension_Upper-Arms-FIX",
  "gymvisualProductId": 1852,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-preacher-curl": {
  "assetId": "23851301",
  "file": "23851301-Dumbbell-Preacher-Curl-(female)_Upper-Arms",
  "gymvisualProductId": 5344,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-rear-delt-row": {
  "assetId": "03771301",
  "file": "03771301-Dumbbell-Rear-Delt-Row_shoulder",
  "gymvisualProductId": 1878,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-reverse-curl": {
  "assetId": "26441301",
  "file": "26441301-Dumbbell-Biceps-Curl-Reverse-(female)_Upper-Arms",
  "gymvisualProductId": 6032,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-romanian-deadlift": {
  "assetId": "22221301",
  "file": "22221301-Dumbbell-Romanian-Deadlift-(female)_Hips",
  "gymvisualProductId": 4292,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-row": {
  "assetId": "24821301",
  "file": "24821301-Dumbbell-Bent-Over-Row-(female)_Back",
  "gymvisualProductId": 5930,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-shoulder-press": {
  "assetId": "04051301",
  "file": "04051301-Dumbbell-Seated-Shoulder-Press_Shoulders",
  "gymvisualProductId": 1906,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-shrug": {
  "assetId": "25961301",
  "file": "25961301-Dumbbell-Shrug-(female)_Back",
  "gymvisualProductId": 5991,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-side-bend": {
  "assetId": "04071301",
  "file": "04071301-Dumbbell-Side-Bend_Waist-FIX",
  "gymvisualProductId": 1908,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-standing-triceps-extension": {
  "assetId": "04301301",
  "file": "04301301-Dumbbell-Standing-Triceps-Extension_Upper-Arms-FIX",
  "gymvisualProductId": 1931,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-thruster": {
  "assetId": "29691301",
  "file": "29691301-Dumbbell-Thruster-(female)",
  "gymvisualProductId": 6494,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-upright-row": {
  "assetId": "34311301",
  "file": "34311301-Dumbbell-Upright-Row-(female)_shoulder",
  "gymvisualProductId": 8829,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-walking-lunges": {
  "assetId": "15571301",
  "file": "15571301-Dumbbell-Walking-Lunges_Thighs",
  "gymvisualProductId": 3422,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "dumbbell-wrist-extension": {
  "assetId": "26301301",
  "file": "26301301-Dumbbell-Over-Bench-Revers-Wrist-Curl-(female)_Forearms",
  "gymvisualProductId": 6018,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "eccentric-hammer-supination": {
  "assetId": "42311301",
  "file": "42311301-Weighted-Seated-Supination_Forearms",
  "gymvisualProductId": 10261,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "eccentric-preacher-curl": {
  "assetId": "00701301",
  "file": "00701301-Barbell-Preacher-Curl_Upper-Arms",
  "gymvisualProductId": 1564,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "elliptical": {
  "assetId": "36241301",
  "file": "36241301-Walk-Elliptical-Cross-Trainer-(female)_Cardio",
  "gymvisualProductId": 9902,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "exercise-bike": {
  "assetId": "00031301",
  "file": "00031301-air-bike-m_waist_FIX",
  "gymvisualProductId": 1485,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "ez-bar-reverse-curl": {
  "assetId": "24981301",
  "file": "24981301-EZ-Barbell-Reverse-Grip-Curl-(female)_Forearms",
  "gymvisualProductId": 5944,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "face-pull": {
  "assetId": "56091301",
  "file": "56091301-Cable-Standing-Face-Pull_Shoulders",
  "gymvisualProductId": 14040,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "farmer-carry": {
  "assetId": "29171301",
  "file": "29171301-Dumbbell-Farmers-Carry_Thighs",
  "gymvisualProductId": 6731,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "frog-pump": {
  "assetId": "31811301",
  "file": "31811301-Bodyweight-Frog-Pump_Hips",
  "gymvisualProductId": 7068,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "front-squat": {
  "assetId": "25021301",
  "file": "25021301-Barbell-Front-Squat-(female)_Thighs",
  "gymvisualProductId": 5948,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "glute-bridge": {
  "assetId": "24711301",
  "file": "24711301-Glute-Bridge-Two-Legs-on-Floor_Hips",
  "gymvisualProductId": 5512,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "glute-ham-raise": {
  "assetId": "57771301",
  "file": "57771301-Glute-Ham-Raise-(VERSION-2)-(female)_Thighs",
  "gymvisualProductId": 20973,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "goblet-squat": {
  "assetId": "22811301",
  "file": "22811301-Dumbbell-Goblet-Squat-(female)_Thighs",
  "gymvisualProductId": 4782,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "good-morning": {
  "assetId": "00441301",
  "file": "00441301-Barbell-Good-Morning_Thighs",
  "gymvisualProductId": 1538,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "hack-squat": {
  "assetId": "26381301",
  "file": "26381301-Barbell-Hack-Squat-(female)_Hips",
  "gymvisualProductId": 6026,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "hack-squat-machine": {
  "assetId": "07431301",
  "file": "07431301-Sled-Hack-Squat_Hips-FIX",
  "gymvisualProductId": 2226,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "hammer-curl": {
  "assetId": "22391301",
  "file": "22391301-Dumbbell-Hammer-Curl-(female)_Upper-Arms",
  "gymvisualProductId": 4309,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "handstand-push-up": {
  "assetId": "23831301",
  "file": "23831301-Handstand-Push-Up-(female)_Upper-Arms",
  "gymvisualProductId": 5342,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "hang-clean": {
  "assetId": "15201301",
  "file": "15201301-Barbell-Hang-Clean_Weightlifts",
  "gymvisualProductId": 3383,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "hanging-knee-raise": {
  "assetId": "98191301",
  "file": "98191301-Hanging-Knee-Raise-(male)_Waist",
  "gymvisualProductId": 24537,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "hanging-leg-raise": {
  "assetId": "04721301",
  "file": "04721301-Hanging-Leg-Raise_Hips",
  "gymvisualProductId": 1971,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "hip-abduction-machine": {
  "assetId": "05971301",
  "file": "05971301-Lever-Seated-Hip-Abduction_Hips-FIX",
  "gymvisualProductId": 2094,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "hip-adduction-machine": {
  "assetId": "05981301",
  "file": "05981301-Lever-Seated-Hip-Adduction_Hips-FIX",
  "gymvisualProductId": 2095,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "hip-thrust-machine": {
  "assetId": "21461301",
  "file": "21461301-Lever-Hip-Thrust_Hips",
  "gymvisualProductId": 4198,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "hollow-hold": {
  "assetId": "71571301",
  "file": "71571301-Hollow-Hold-(female)_Waist",
  "gymvisualProductId": 19628,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "incline-bench-press": {
  "assetId": "23881301",
  "file": "23881301-Barbell-Incline-Bench-Press-(female)_Chest",
  "gymvisualProductId": 5347,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "incline-cable-fly": {
  "assetId": "30501301",
  "file": "30501301-Cable-Incline-Fly-(female)_Chest",
  "gymvisualProductId": 8263,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "incline-dumbbell-curl": {
  "assetId": "24931301",
  "file": "24931301-Dumbbell-Incline-Biceps-Curl-(female)_Upper-Arms",
  "gymvisualProductId": 5939,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "incline-dumbbell-fly": {
  "assetId": "25141301",
  "file": "25141301-Dumbbell-Incline-Fly-(female)_Chest",
  "gymvisualProductId": 5960,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "incline-dumbbell-press": {
  "assetId": "24411301",
  "file": "24411301-Dumbbell-Incline-Bench-Press-(female)_Chest",
  "gymvisualProductId": 5908,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "incline-machine-chest-press": {
  "assetId": "24551301",
  "file": "24551301-Lever-Incline-Chest-Press-(female)_Chest",
  "gymvisualProductId": 5921,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "incline-push-up": {
  "assetId": "04931301",
  "file": "04931301-Incline-Push-up_Chest",
  "gymvisualProductId": 1992,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "inverted-row": {
  "assetId": "04991301",
  "file": "04991301-Inverted-Row_Back-FIX",
  "gymvisualProductId": 1998,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "isometric-biceps-hold": {
  "assetId": "101381301",
  "file": "101381301-Standing-Isometric-Biceps-Hold_Stretching",
  "gymvisualProductId": 23663,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "isometric-scapular-retraction-hold": {
  "assetId": "110571301",
  "file": "110571301-Cable-Seated-Scapular-Retraction_Back",
  "gymvisualProductId": 24155,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "isometric-squat-hold": {
  "assetId": "66961301",
  "file": "66961301-Sit-(wall)-(female)_Thighs",
  "gymvisualProductId": 16674,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "jump-lunge": {
  "assetId": "35821301",
  "file": "35821301-Lunge-with-Jump_Thighs",
  "gymvisualProductId": 8122,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "jump-rope": {
  "assetId": "05111301",
  "file": "05111301-Jump-Rope-(female)_Cardio-FIX",
  "gymvisualProductId": 2009,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "jump-squat": {
  "assetId": "23741301",
  "file": "23741301-Jump-Squat-(female)_Thighs",
  "gymvisualProductId": 5333,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "kettlebell-clean": {
  "assetId": "45301301",
  "file": "45301301-Kettlebell-Single-Arm-Clean-(female)_Weightlifts",
  "gymvisualProductId": 10532,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "kettlebell-goblet-squat": {
  "assetId": "05341301",
  "file": "05341301-Kettlebell-Goblet-Squat_thighs",
  "gymvisualProductId": 2032,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "kettlebell-snatch": {
  "assetId": "45321301",
  "file": "45321301-Kettlebell-Snatch-(female)_Weightlifts",
  "gymvisualProductId": 10534,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "kettlebell-swing": {
  "assetId": "05491301",
  "file": "05491301-Kettlebell-Swing_Hips-FIX",
  "gymvisualProductId": 2047,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "kneeling-ab-wheel": {
  "assetId": "23321301",
  "file": "23321301-Wheel-Rollout-(female)_Waist",
  "gymvisualProductId": 5183,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "landmine-press": {
  "assetId": "35251301",
  "file": "35251301-Landmine-Kneeling-One-Arm-Shoulder-Press_Shoulders",
  "gymvisualProductId": 8849,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "landmine-rotation": {
  "assetId": "36051301",
  "file": "36051301-Landmine-180-(female)_waist",
  "gymvisualProductId": 9883,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "lat-pulldown": {
  "assetId": "22471301",
  "file": "22471301-Cable-Bar-Lateral-Pulldown-(female)_Back",
  "gymvisualProductId": 4317,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "lat-pulldown-with-neutral-grip": {
  "assetId": "75831301",
  "file": "75831301-Cable-Neutral-Grip-Lat-Pulldown-(male)_Back",
  "gymvisualProductId": 18251,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "lateral-lunge": {
  "assetId": "48531301",
  "file": "48531301-Dumbbell-Lateral-Lunge_Thighs",
  "gymvisualProductId": 12369,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "lateral-raise": {
  "assetId": "03341301",
  "file": "03341301-Dumbbell-Lateral-Raise_shoulder-AFIX",
  "gymvisualProductId": 1835,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "lean-away-cable-lateral-raise": {
  "assetId": "38801301",
  "file": "38801301-Cable-Leaning-Lateral-Raise_Shoulders",
  "gymvisualProductId": 10005,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "leg-curl": {
  "assetId": "22231301",
  "file": "22231301-Lever-Lying-Leg-Curl-(female)_Thighs",
  "gymvisualProductId": 4293,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "leg-extension": {
  "assetId": "22561301",
  "file": "22561301-Lever-Leg-Extension-(female)_Thighs",
  "gymvisualProductId": 4326,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "leg-press": {
  "assetId": "22241301",
  "file": "22241301-Sled-45-degrees-Leg-Press-(female)_Thighs",
  "gymvisualProductId": 4294,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "lunge-bodyweight": {
  "assetId": "49501301",
  "file": "49501301-Bodyweight-Forward-Lunge-(Smaller-Stance-Upright-Torso)_Thighs",
  "gymvisualProductId": 12390,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "lying-triceps-extension-with-ez-bar": {
  "assetId": "36461301",
  "file": "36461301-EZ-Barbell-Lying-Triceps-Extension-(female)_Upper-Arms",
  "gymvisualProductId": 8882,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "machine-bicep-curl": {
  "assetId": "43361301",
  "file": "43361301-Lever-Biceps-Curl_Upper-Arms-FIX",
  "gymvisualProductId": 12122,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "machine-chest-press": {
  "assetId": "24571301",
  "file": "24571301-Lever-Chest-Press-(female)_Chest",
  "gymvisualProductId": 5923,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "machine-crunch": {
  "assetId": "14521301",
  "file": "14521301-Lever-Seated-Crunch_Waist",
  "gymvisualProductId": 2925,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "machine-high-row": {
  "assetId": "31001301",
  "file": "31001301-Lever-High-Row-(plate-loaded)-(female)_Back",
  "gymvisualProductId": 8313,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "machine-lat-pulldown": {
  "assetId": "18701301",
  "file": "18701301-Lever-Lateral-Pulldown-(plate-loaded)_Back",
  "gymvisualProductId": 4574,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "machine-lateral-raise": {
  "assetId": "05841301",
  "file": "05841301-Lever-Lateral-Raise_shoulder",
  "gymvisualProductId": 2081,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "machine-pec-deck": {
  "assetId": "10301301",
  "file": "10301301-Lever-Pec-Deck-Fly_Chest",
  "gymvisualProductId": 2499,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "machine-row": {
  "assetId": "22461301",
  "file": "22461301-Lever-Seated-Row-(female)_Back",
  "gymvisualProductId": 4316,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "machine-shoulder-press": {
  "assetId": "14541103",
  "file": "14541103-Lever-Seated-Shoulder-Press_Shoulders",
  "gymvisualProductId": 2927,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "mountain-climbers": {
  "assetId": "46451301",
  "file": "46451301-Mountain-Climber-(female)_Cardio",
  "gymvisualProductId": 15220,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "muscle-snatch": {
  "assetId": "15261301",
  "file": "15261301-Barbell-Muscle-Snatch_Weightlifts-FIX",
  "gymvisualProductId": 3389,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "muscle-up": {
  "assetId": "06311301",
  "file": "06311301-Muscle-Up_Back-FIX",
  "gymvisualProductId": 2126,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "neutral-grip-pull-up": {
  "assetId": "06511301",
  "file": "06511301-Pull-up-(neutral-grip)_Back",
  "gymvisualProductId": 2144,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "nordic-curl": {
  "assetId": "77461301",
  "file": "77461301-Nordic-Hamstring-Curl-(male)_Thighs",
  "gymvisualProductId": 18424,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "oblique-crunch": {
  "assetId": "06351301",
  "file": "06351301-Oblique-Crunches-Floor_waist",
  "gymvisualProductId": 2129,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "one-arm-cable-row": {
  "assetId": "53691301",
  "file": "53691301-Cable-Kneeling-One-Arm-Row_Back",
  "gymvisualProductId": 13107,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "one-arm-dumbbell-press": {
  "assetId": "03421301",
  "file": "03421301-Dumbbell-Lying-One-Arm-Press-II_Chest",
  "gymvisualProductId": 1843,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "one-arm-landmine-press": {
  "assetId": "107661301",
  "file": "107661301-Landmine-Single-Arm-Press-(female)_Shoulders",
  "gymvisualProductId": 23512,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "one-arm-lat-pulldown": {
  "assetId": "12041301",
  "file": "12041301-Cable-one-arm-lat-pulldown_back",
  "gymvisualProductId": 2654,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "one-legged-leg-press": {
  "assetId": "14251301",
  "file": "14251301-Sled-45-degrees-One-Leg-Press_Hips",
  "gymvisualProductId": 3198,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "one-legged-seated-leg-press": {
  "assetId": "71071301",
  "file": "71071301-Lever-Seated-Single-Leg-Press-(VERSION-2)_Thighs",
  "gymvisualProductId": 17732,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "overhead-cable-triceps-extension": {
  "assetId": "01941301",
  "file": "01941301-Cable-Overhead-Triceps-Extension-(rope-attachment)_Upper-Arms",
  "gymvisualProductId": 1687,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "overhead-carry": {
  "assetId": "29131301",
  "file": "29131301-Dumbbell-Overhead-Carry_Thighs",
  "gymvisualProductId": 6727,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "overhead-press": {
  "assetId": "11621301",
  "file": "11621301-Barbell-Standing-Military-Press_Shoulders",
  "gymvisualProductId": 2617,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "overhead-triceps-extension": {
  "assetId": "46671301",
  "file": "46671301-Bodyweight-Overhead-Triceps-Extension-(female)_Upper-Arms",
  "gymvisualProductId": 13470,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "pallof-press": {
  "assetId": "80431301",
  "file": "80431301-Cable-Horizontal-Pallof-Press-(female)_Waist",
  "gymvisualProductId": 22891,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "pause-deadlift": {
  "assetId": "50141301",
  "file": "50141301-Barbell-Pause-Deadlift_Hips",
  "gymvisualProductId": 14247,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "pause-squat": {
  "assetId": "50171301",
  "file": "50171301-Pause-Squat_Thighs",
  "gymvisualProductId": 25584,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "pendlay-row": {
  "assetId": "30171301",
  "file": "30171301-Barbell-Pendlay-Row_Back",
  "gymvisualProductId": 6574,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "pendulum-squat": {
  "assetId": "49511301",
  "file": "49511301-Lever-Pendulum-Squat-(plate-loaded)_Thighs",
  "gymvisualProductId": 12391,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "pike-push-up": {
  "assetId": "29211301",
  "file": "29211301-Pike-Push-up_Chest",
  "gymvisualProductId": 6735,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "pistol-squat": {
  "assetId": "07321301",
  "file": "07321301-Single-Leg-Squat-(pistol)-(female)_Hips-FIX2",
  "gymvisualProductId": 2216,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "plank": {
  "assetId": "04651301",
  "file": "04651301-Front-Plank_Waist",
  "gymvisualProductId": 4402,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "plate-wrist-curl": {
  "assetId": "03691301",
  "file": "03691301-Dumbbell-Over-Bench-Wrist-Curl_Forearms",
  "gymvisualProductId": 1870,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "power-clean": {
  "assetId": "06481301",
  "file": "06481301-Power-Clean_Weightlifting-FIX",
  "gymvisualProductId": 2141,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "power-jerk": {
  "assetId": "15291301",
  "file": "15291301-Barbell-Power-Jerk_Weightlifts",
  "gymvisualProductId": 3392,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "prone-incline-barbell-curl": {
  "assetId": "25061301",
  "file": "25061301-Barbell-Prone-Incline-Curl-(female)_Upper-Arms",
  "gymvisualProductId": 5952,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "prone-t-raise": {
  "assetId": "50411301",
  "file": "50411301-Lying-Prone-T_Back",
  "gymvisualProductId": 13651,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "prone-w-raise": {
  "assetId": "50421301",
  "file": "50421301-Lying-Prone-W_Back",
  "gymvisualProductId": 13652,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "prone-y-raise": {
  "assetId": "58221301",
  "file": "58221301-Prone-Y-Raise-(male)_Back",
  "gymvisualProductId": 14544,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "pull-up": {
  "assetId": "06521301",
  "file": "06521301-Pull-up_Back",
  "gymvisualProductId": 2145,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "pullover": {
  "assetId": "03751301",
  "file": "03751301-Dumbbell-Pullover_Chest",
  "gymvisualProductId": 1876,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "push-press": {
  "assetId": "12001301",
  "file": "12001301-Push-Press_Shoulders",
  "gymvisualProductId": 2651,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "push-up": {
  "assetId": "28811301",
  "file": "28811301-Push-up_Pilates",
  "gymvisualProductId": 9830,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "rack-pull": {
  "assetId": "00741301",
  "file": "00741301-Barbell-Rack-Pull_Hips-FIX",
  "gymvisualProductId": 1568,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "reverse-crunch": {
  "assetId": "06711301",
  "file": "06711301-Reverse-Crunch_waist",
  "gymvisualProductId": 2164,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "reverse-dumbbell-flyes": {
  "assetId": "03831301",
  "file": "03831301-Dumbbell-Reverse-Fly_Shoulders",
  "gymvisualProductId": 1884,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "reverse-grip-bench-press": {
  "assetId": "50911301",
  "file": "50911301-Barbell-Reverse-Grip-Bench-Press_Chest",
  "gymvisualProductId": 13554,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "reverse-grip-lat-pulldown": {
  "assetId": "105031301",
  "file": "105031301-Cable-Reverse-Narrow-grip-Lat-Pulldown-(male)_Back",
  "gymvisualProductId": 24467,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "reverse-grip-triceps-pushdown": {
  "assetId": "25201301",
  "file": "25201301-Cable-Reverse-grip-Pushdown-(female)_Upper-Arms",
  "gymvisualProductId": 5966,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "reverse-hack-squat": {
  "assetId": "57841301",
  "file": "57841301-Lever-Reverse-Vertical-Hack-Squat-(female)_Hips",
  "gymvisualProductId": 15961,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "reverse-hyperextension": {
  "assetId": "05931301",
  "file": "05931301-Lever-Reverse-Hyperextension-(plate-loaded)_Hips",
  "gymvisualProductId": 2090,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "reverse-pec-deck": {
  "assetId": "06021301",
  "file": "06021301-Lever-Seated-Reverse-Fly_Shoulders",
  "gymvisualProductId": 2099,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "romanian-deadlift": {
  "assetId": "22131301",
  "file": "22131301-Barbell-Romanian-Deadlift-(female)_Hips-FIX",
  "gymvisualProductId": 4283,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "rowing-machine": {
  "assetId": "22621301",
  "file": "22621301-Rowing-(with-rowing-machine)-(female)_Cardio",
  "gymvisualProductId": 4769,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "scap-pull-ups": {
  "assetId": "06881301",
  "file": "06881301-Scapular-Pull-Up_back",
  "gymvisualProductId": 2180,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "seal-row": {
  "assetId": "87981301",
  "file": "87981301-Barbell-Lying-Seal-Row-on-Rack_Back",
  "gymvisualProductId": 21577,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "seated-barbell-shoulder-press": {
  "assetId": "26041301",
  "file": "26041301-Barbell-Seated-Overhead-Press-(female)_Shoulders",
  "gymvisualProductId": 5998,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "seated-cable-chest-fly": {
  "assetId": "38691301",
  "file": "38691301-Cable-Seated-Chest-Fly_Chest",
  "gymvisualProductId": 9994,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "seated-calf-raise": {
  "assetId": "31061301",
  "file": "31061301-Lever-Seated-Calf-Raise-(plate-loaded)-(female)_Calves",
  "gymvisualProductId": 8319,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "seated-dumbbell-shoulder-press": {
  "assetId": "22371301",
  "file": "22371301-Dumbbell-Seated-Shoulder-Press-(female)_Shoulders",
  "gymvisualProductId": 4307,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "seated-good-morning": {
  "assetId": "26021301",
  "file": "26021301-Barbell-Seated-Good-morning-(female)_Hips",
  "gymvisualProductId": 5996,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "seated-leg-curl": {
  "assetId": "22571301",
  "file": "22571301-Lever-Seated-Leg-Curl-(female)_Thighs-FIX",
  "gymvisualProductId": 4327,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "seated-leg-press": {
  "assetId": "22671301",
  "file": "22671301-Lever-Seated-Leg-Press_Thighs",
  "gymvisualProductId": 4774,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "side-plank": {
  "assetId": "07151301",
  "file": "07151301-Side-Plank-(male)_Waist-FIX",
  "gymvisualProductId": 4414,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "single-leg-calf-raise": {
  "assetId": "04091301",
  "file": "04091301-Dumbbell-Single-Leg-Calf-Raise_Calves-FIX",
  "gymvisualProductId": 1910,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "single-leg-hip-thrust": {
  "assetId": "47921301",
  "file": "47921301-Single-Leg-Hip-Thrust-(VERSION-2)-(female)_Hips-FIX",
  "gymvisualProductId": 10981,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "sissy-squat": {
  "assetId": "40321301",
  "file": "40321301-Weighted-Sissy-Squat-(female)_Thighs",
  "gymvisualProductId": 10099,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "ski-erg": {
  "assetId": "21421301",
  "file": "21421301-Ski-Ergometer_Cardio",
  "gymvisualProductId": 4188,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "sled-push": {
  "assetId": "25241301",
  "file": "25241301-Power-Sled-Push-(female)_Thighs",
  "gymvisualProductId": 5525,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "smith-machine-bench-press": {
  "assetId": "70021301",
  "file": "70021301-Smith-Bench-Press-(female)_Chest",
  "gymvisualProductId": 23973,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "smith-machine-bulgarian-split-squat": {
  "assetId": "26701301",
  "file": "26701301-Smith-Single-Leg-Split-Squat-(female)_thighs",
  "gymvisualProductId": 6047,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "smith-machine-calf-raise": {
  "assetId": "07731301",
  "file": "07731301-Smith-Standing-Leg-Calf-Raise_Calves-FIX",
  "gymvisualProductId": 2256,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "smith-machine-decline-bench-press": {
  "assetId": "07531301",
  "file": "07531301-Smith-Decline-Bench-Press_Chest",
  "gymvisualProductId": 2236,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "smith-machine-incline-bench-press": {
  "assetId": "70031301",
  "file": "70031301-Smith-Incline-Bench-Press-(female)_Chest",
  "gymvisualProductId": 23975,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "smith-machine-row": {
  "assetId": "13591301",
  "file": "13591301-Smith-Bent-Over-Pronated-Grip-Row_Back-FIX",
  "gymvisualProductId": 3129,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "smith-machine-shoulder-press": {
  "assetId": "36201301",
  "file": "36201301-Smith-Seated-Shoulder-Press-(female)_Shoulders-FIX",
  "gymvisualProductId": 9898,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "smith-machine-squat": {
  "assetId": "07701301",
  "file": "07701301-Smith-Squat_Hips",
  "gymvisualProductId": 2253,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "snatch": {
  "assetId": "15221301",
  "file": "15221301-Barbell-Hang-Snatch_Weightlifts",
  "gymvisualProductId": 3385,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "snatch-grip-deadlift": {
  "assetId": "72381301",
  "file": "72381301-Barbell-Snatch-grip-Deadlift-(male)_Hips",
  "gymvisualProductId": 17605,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "split-jerk": {
  "assetId": "15381301",
  "file": "15381301-Barbell-Split-Jerk_Weightlifts",
  "gymvisualProductId": 3404,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "split-squat": {
  "assetId": "29591301",
  "file": "29591301-Dumbbell-Split-Squat-(female)_Thighs-FIX",
  "gymvisualProductId": 8218,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "stair-climber": {
  "assetId": "30091301",
  "file": "30091301-Stair-Up-(female)_Thighs",
  "gymvisualProductId": 6566,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "standing-cable-chest-fly-upper-position": {
  "assetId": "02271301",
  "file": "02271301-Cable-Standing-Fly_Chest-FIX",
  "gymvisualProductId": 1720,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "standing-calf-raise": {
  "assetId": "22111301",
  "file": "22111301-Lever-Standing-Calf-Raise-(female)_Calves",
  "gymvisualProductId": 4281,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "step-up": {
  "assetId": "08011301",
  "file": "08011301-Step-up_Hips",
  "gymvisualProductId": 2283,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "stiff-legged-deadlift": {
  "assetId": "15431301",
  "file": "15431301-Barbell-Stiff-Legged-Deadlift_Hips",
  "gymvisualProductId": 3409,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "straight-arm-lat-pulldown": {
  "assetId": "02381301",
  "file": "02381301-Cable-Straight-Arm-Pulldown_Back-FIX",
  "gymvisualProductId": 1731,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "suitcase-carry": {
  "assetId": "29101301",
  "file": "29101301-Dumbbell-Suitcase-Carry_Thighs",
  "gymvisualProductId": 6724,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "sumo-deadlift": {
  "assetId": "25171301",
  "file": "25171301-Barbell-Sumo-Deadlift-(female)_Hips",
  "gymvisualProductId": 5963,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "svend-press": {
  "assetId": "34261301",
  "file": "34261301-Weighted-Svend-Press-(female)_Chest",
  "gymvisualProductId": 8824,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "t-bar-row": {
  "assetId": "28851301",
  "file": "28851301-Lever-T-bar-Row-(plate-loaded)-(female)_Back",
  "gymvisualProductId": 8198,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "tate-press": {
  "assetId": "04361301",
  "file": "04361301-Dumbbell-Tate-Press_Triceps",
  "gymvisualProductId": 1937,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "tibialis-raise": {
  "assetId": "98031301",
  "file": "98031301-Standing-Tibialis-Raise-Wall-Supported-(male)_Calves",
  "gymvisualProductId": 23661,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "toes-to-bar": {
  "assetId": "38911301",
  "file": "38911301-Hanging-Toes-to-Bar_Waist",
  "gymvisualProductId": 10012,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "trap-bar-deadlift": {
  "assetId": "08111301",
  "file": "08111301-Trap-Bar-Deadlift_Thighs-FIX",
  "gymvisualProductId": 2293,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "treadmill-run": {
  "assetId": "21971301",
  "file": "21971301-Run-on-Treadmill-(female)_Cardio",
  "gymvisualProductId": 4764,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "tricep-kickback": {
  "assetId": "24371301",
  "file": "24371301-Dumbbell-Kickback-(female)_Upper-arms",
  "gymvisualProductId": 5904,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "triceps-pushdown": {
  "assetId": "02411301",
  "file": "02411301-Cable-Triceps-Pushdown-(V-bar-attachment)_Upper-Arms",
  "gymvisualProductId": 1734,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "turkish-get-up": {
  "assetId": "40571301",
  "file": "40571301-Kettlebell-Turkish-Get-Up-to-Hand_Thighs",
  "gymvisualProductId": 10124,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "underhand-barbell-row": {
  "assetId": "24671301",
  "file": "24671301-Barbell-Reverse-Grip-Bent-Over-Row-(female)_Back",
  "gymvisualProductId": 5501,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "walking": {
  "assetId": "22611301",
  "file": "22611301-Walking-(female)_Cardio",
  "gymvisualProductId": 4768,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "walking-lunge": {
  "assetId": "38111301",
  "file": "38111301-Walking-Lunge-(female)_Thighs",
  "gymvisualProductId": 13425,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "weighted-pull-up": {
  "assetId": "08411301",
  "file": "08411301-Weighted-Pull-Up_back",
  "gymvisualProductId": 2322,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "wide-grip-lat-pulldown": {
  "assetId": "22911301",
  "file": "22911301-Cable-Wide-Grip-Lat-Pulldown-(female)_Back",
  "gymvisualProductId": 4905,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "wide-grip-pull-up": {
  "assetId": "36271301",
  "file": "36271301-Wide-Grip-Pull-Up-(female)_Back",
  "gymvisualProductId": 9905,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "wrist-roller": {
  "assetId": "08591301",
  "file": "08591301-Wrist-Roller_Forearms",
  "gymvisualProductId": 2340,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "zercher-squat": {
  "assetId": "01271301",
  "file": "01271301-Barbell-Zercher-Squat_Hips",
  "gymvisualProductId": 1625,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 },
 "zottman-curl": {
  "assetId": "04391301",
  "file": "04391301-Dumbbell-Zottman-Curl_Upper-Arms-FIX2",
  "gymvisualProductId": 1940,
  "resolutions": [
   180,
   360,
   720,
   1080
  ]
 }
}
